module.exports = __webpack_public_path__ + "stripe-mark-blurple.aa68b4.svg";